import * as breakpoints from "../styles/breakpoints";
import * as colors from "../styles/colors";
import * as docketPropTypes from "../docketPropTypes";
import appStyles from "../styles/appStyles";
import CircularProgress from "./mui/CircularProgress";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite";

const PROGRESS_WIDTH = 24;
const styles = StyleSheet.create({
	formSubmitButton: {
		position: "relative",
		border: 10,
		boxSizing: "border-box",
		display: "inline-block",
		cursor: "pointer",
		textDecoration: "none",
		margin: 0,
		padding: 0,
		outline: "none",
		fontSize: "inherit",
		fontWeight: "inherit",
		zIndex: 1,
		height: 36,
		lineHeight: "36px",
		minWidth: 88,
		color: colors.textDarkGrey3,
		borderRadius: 2,
		userSelect: "none",
		overflow: "hidden",
		backgroundColor: colors.white,
		textAlign: "center",
		opacity: 1,
		transition: "background-color 0.3s",
	},
	label: {
		position: "relative",
		paddingLeft: 16,
		paddingRight: 16,
		verticalAlign: "middle",
		letterSpacing: 0,
		textTransform: "uppercase",
		fontWeight: 500,
		fontSize: 14,
		bottom: 2,
		color: colors.docketLightishBlue,
	},
	hover: {
		[breakpoints.desktopTrue]: {
			":hover": {
				backgroundColor: colors.docketLightGrey20,
			},
		},
	},
	spinnerContainer: {
		position: "absolute",
		pointerEvents: "none",
		top: 6,
		left: `calc(50% - ${PROGRESS_WIDTH / 2}px)`,
	},
	visible: {
		opacity: 1.0,
	},
	invisible: {
		opacity: 0.0,
	},
});

export default class FormSubmitButton extends PureComponent {
	static propTypes = {
		aStyles: docketPropTypes.aphroditeStyles,
		aStylesLabel: docketPropTypes.aphroditeStyles,
		disabled: PropTypes.bool.isRequired,
		label: PropTypes.string.isRequired,
		loading: PropTypes.bool.isRequired,
		loadingColor: PropTypes.string.isRequired,
	};

	static defaultProps = {
		disabled: false,
		loading: false,
		loadingColor: colors.docketLightishBlue,
	};

	render() {
		const disabled = this.props.disabled || this.props.loading;
		return (
			<button
				className={css(
					styles.formSubmitButton,
					disabled ? null : styles.hover,
					this.props.aStyles,
				)}
				disabled={disabled}
				type="submit"
			>
				<span
					className={css(
						appStyles.baseFont,
						styles.label,
						this.props.loading ? styles.invisible : styles.visible,
						this.props.aStylesLabel,
					)}
				>
					{this.props.label}
				</span>
				<div
					className={css(
						styles.spinnerContainer,
						this.props.loading ? styles.visible : styles.invisible,
					)}
				>
					<CircularProgress
						color={this.props.loadingColor}
						size={PROGRESS_WIDTH}
						thickness={2}
					/>
				</div>
			</button>
		);
	}
}
